module.exports = __webpack_public_path__ + "img/fangkuanzhong.61e8805a.png";